import { Injectable } from '@angular/core';
import { Document } from '../models/document.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import documentQuery from 'src/app/graphql/queries/document.query.graphql'
import documentsQuery from 'src/app/graphql/queries/documents.query.graphql'

@Injectable()
export class DocumentService extends GraphQLService<Document> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  documents(iso: string, unames: string[]) {
    return this.findAll(documentsQuery, {iso, unames: unames.join(',')})
  }

  document(id: number, iso: string) {
    return this.find(documentQuery, {id, iso})
  }

}
